import { CacheProvider } from '@emotion/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga';

import './config/sentry';

import * as Sentry from '@sentry/react';
import { createBrowserRouter, RouterProvider } from 'react-router';

import App from './App';
import Layout from './App/Layout';
import { ADMIN_ROUTES } from './areas/Admin/routes';
import ForgotPassword from './areas/Authorization/ForgotPassword';
import Login from './areas/Authorization/Login';
import Logout from './areas/Authorization/Logout';
import ResetPassword from './areas/Authorization/ResetPassword';
import Signup from './areas/Authorization/Signup';
import NotFound from './areas/NotFound';
import Restricted from './areas/Restricted';
import createEmotionCache from './createEmotionCache';
import * as ENV from './environments/environment';

console.log('environment test', ENV, process.env);

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

ReactGA.initialize(ENV.REACT_APP_GA_TOKEN);
ReactGA.pageview(window.location.pathname + window.location.search);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
    {
        Component: App, // root layout route
        children: [
            {
                path: '/',
                Component: Layout,
                children: ADMIN_ROUTES,
            },
            {
                path: '/login',
                Component: Login,
            },
            {
                path: '/signup',
                Component: Signup,
            },
            {
                path: '/forgot-password',
                Component: ForgotPassword,
            },
            {
                path: '/reset-password/',
                Component: ResetPassword,
            },
            {
                path: '/logout',
                Component: Logout,
            },
            {
                path: '/restricted',
                Component: Restricted,
            },
            {
                path: '/*',
                Component: NotFound,
            },
        ],
    },
]);
root.render(
    <StrictMode>
        <CacheProvider value={clientSideEmotionCache}>
            <RouterProvider router={router} />
        </CacheProvider>
    </StrictMode>
);
